<template>
	<v-expansion-panel class="expansion-container">
		<v-expansion-panel-header :class="['px-0', 'small-icon']">
			<div class="panel-title">{{ title }}</div>
		</v-expansion-panel-header>
		<v-expansion-panel-content class="px-0">
			<slot />
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>
<script>
export default {
	name: 'ExpansionPanel',
	props: {
		title: { type: String },
	},
};
</script>
<style scoped lang="scss">
.expansion-container {
	background: transparent;
	border-bottom: 1px solid var(--border-color);

	.panel-title {
		font-size: 12px;
		font-weight: 600;
		color: var(--bold-title);
	}

	::v-deep(.v-expansion-panel-content__wrap) {
		// Adding scroll to very long expanded content so page doesn't overflow
		// e.g. Many Dropdown Options
		max-height: 50vh;
		overflow: auto;
	}
}
</style>
